import { api } from '@/api'
import find from 'lodash/find'
import { createLink } from '@/api/helpers'

function filterTags(tags, contentType, user) {
  return tags.filter((tag) => {
    return tag.content_types.includes(contentType)
  })
}

const state = {
  tags: [],
}

const mutations = {
  setTags(store, tags) {
    store.tags = tags
  },
}

const actions = {
  async fetch({ commit }) {
    commit('setTags', (await api.get(createLink('tag'))).data)
  },
}

const getters = {
  getTags: (store) => (contentType, user) => {
    return filterTags(store.tags, contentType, user)
  },
  getTagForSlug: (store) => (slug) => {
    return find(store.tags, { slug })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
